import React, { useState } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { formatDate } from '@src/utils';
import { useGetMonitorQuery } from '@src/store/services/cdb/onlineServices';

const TransactionItem = ({
  children,
  paddingTop = '0',
  paddingBottom = '0',
}) => {
  return (
    <Grid.Col
      css={{
        paddingBottom,
        paddingTop,
        alignItems: 'center',
        display: 'flex',
        gap: '5px',
      }}
      span={{
        xs: '100%',
        sm: '100%',
        md: '100%',
        lg: '100%',
        xl: '100%',
      }}
    >
      {children}
    </Grid.Col>
  );
};

export const Monitor = () => {
  const [date, setDate] = useState(new Date());
  const { fileId } = useRouter().getRouteParams();

  const { data, refetch } = useGetMonitorQuery(fileId);
  const handleRefresh = () => {
    refetch();
    setDate(new Date());
  };

  return (
    <React.Fragment>
      <Router.MetaTags title="Home" />
      <Card
        css={{
          'abyss-card-root': { padding: '0' },
        }}
      >
        <div
          style={{
            backgroundColor:
              'var(--abyss-colors-web-semantic-color-surface-container-primary)',
            color:
              'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
            fontSize: '18px',
            padding: '24px',
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            fontWeight: 'bold',
            height: '68px',
          }}
        >
          Transaction Set Detail Monitor
        </div>
        <div style={{ padding: '16px 24px' }}>
          <Layout.Group alignLayout="center">
            <Grid
              css={{
                paddingBottom: '15px',
                paddingTop: '15px',
                justifyContent: 'center',
              }}
            >
              <TransactionItem paddingBottom="10px">
                <Text
                  fontWeight="bold"
                  css={{ 'abyss-text-root': { fontSize: '28px' } }}
                >
                  Transaction Set Detail
                </Text>
              </TransactionItem>
              <TransactionItem paddingBottom="10px">
                <b>Status at: </b>
                <Text>{formatDate(date)}</Text>
              </TransactionItem>
              <TransactionItem>
                <b>Transaction File Submitter: </b>
                <Text>{data?.[0]?.transFileSubmitter}</Text>
              </TransactionItem>
              <TransactionItem paddingBottom="10px">
                <b>Transaction Set Submitter: </b>
                <Text>{data?.[0]?.transSetSubmitter}</Text>
              </TransactionItem>
              <TransactionItem>
                <b> Transaction Set Id: </b>
                <Text>{data?.[0]?.transSetId}</Text>
              </TransactionItem>
              <TransactionItem>
                <b>Transaction File Id: </b>
                <Text>{data?.[0]?.transFileId}</Text>
              </TransactionItem>
              <TransactionItem paddingBottom="10px">
                <b>Business Process Id: </b>
                <Text>{data?.[0]?.busProcId}</Text>
              </TransactionItem>
              <TransactionItem>
                <b>Set Created: </b>
                <Text>
                  {data?.[0]?.setCreatedDateTime
                    ? formatDate(new Date(data?.[0]?.setCreatedDateTime))
                    : ''}
                </Text>
              </TransactionItem>
              <TransactionItem paddingBottom="10px">
                <b>Status: </b>
                <Text>{data?.[0]?.stsTxt}</Text>
              </TransactionItem>
              <TransactionItem>
                <b>Inbound Record Count: </b>
                <Text>{data?.[0]?.inboundTransactionCount}</Text>
              </TransactionItem>
              <TransactionItem>
                <b>Source Record Count: </b>
                <Text>{data?.[0]?.sourceTransactionCount}</Text>
              </TransactionItem>
              <TransactionItem paddingBottom="10px">
                <b>Transaction Record Count: </b>
                <Text>{data?.[0]?.transactionSetRecordCount}</Text>
              </TransactionItem>
              <TransactionItem>
                <b>Percent Family </b>
              </TransactionItem>
              <TransactionItem paddingBottom="10px">
                <b>Processing Complete:</b>
                <Text>{data?.[0]?.parentFamilyComplete}</Text>
              </TransactionItem>
              <TransactionItem>
                <b>Errors During</b>
              </TransactionItem>
              <TransactionItem paddingBottom="15px">
                <b>Family Processing:</b>
                <Text>{data?.[0]?.errorDuringProcessing}</Text>
              </TransactionItem>
              <TransactionItem>
                <Button
                  size="sm"
                  onClick={() => {
                    handleRefresh();
                  }}
                >
                  Refresh
                </Button>
              </TransactionItem>
            </Grid>
          </Layout.Group>
        </div>
      </Card>
    </React.Fragment>
  );
};
